import { Box } from '@mui/material';
import moment from 'moment';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { useUserState } from '../../../../shared/hooks/accountHook';
import { useNotificationRead } from '../../../../shared/hooks/notificationHook';
import {
  CurrentTimeText,
  CurrentTimeTextLayout,
  SectionContentContainer,
  SectionHeading,
} from '../../common/components/styledComponents';
import { WindowSize, WindowSizeContext } from '../../hooks/windowSizeHook';

import NotificationServiceComponent from './NotificationServices';
import { NotificationTable } from './NotificationTable';

export const Notifications = () => {
  const { t: globalT } = useTranslation();
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.notifications',
  });

  const isMobile = useContext(WindowSizeContext) === WindowSize.MOBILE;

  const currentTime = moment().format(`${globalT('currentTime')}`);
  useNotificationRead();

  const [user] = useUserState();

  return (
    <SectionContentContainer>
      {!user?.identified && (
        <>
          <SectionHeading>{t('headingEN')}</SectionHeading>
          <NotificationServiceComponent isMobile={isMobile} t={t} />
        </>
      )}
      <SectionHeading>{t('heading')}</SectionHeading>
      <CurrentTimeTextLayout
        right={<CurrentTimeText>{currentTime}</CurrentTimeText>}
      />
      <Box width="100%" minHeight="400px">
        <NotificationTable />
      </Box>
    </SectionContentContainer>
  );
};
